// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// TEST:

//const awsmobile = {
//  aws_project_region: "us-west-2",
//  aws_cognito_region: "us-west-2",
//  aws_user_pools_id: "us-west-2_wH335UKwh",
//  aws_user_pools_web_client_id: "4i4ibuh8d840m419egah564av0",
//  oauth: {
//    domain: "amttest.auth.us-west-2.amazoncognito.com",
//    // redirectSignIn: "https://d2p8kbr51o3tqm.cloudfront.net/",
//    // redirectSignOut: "https://d2p8kbr51o3tqm.cloudfront.net/login/",
//    redirectSignIn: "https://amt.tst.globe.life/",
//    redirectSignOut: "https://amt.tst.globe.life/login/",
//    responseType: "code",
//  },
//  aws_appsync_graphqlEndpoint:
//    "https://2kvfvrhg7nfizfoa6x7mbmcirq.appsync-api.us-west-2.amazonaws.com/graphql",
//  aws_appsync_region: "us-west-2",
//  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
//  storage: sessionStorage
//};

// Stage:
// const awsmobile = {
//   aws_project_region: "us-west-2",
//   aws_cognito_region: "us-west-2",
//   aws_user_pools_id: "us-west-2_XOHdSG1Sl",
//   aws_user_pools_web_client_id: "1k55df0m51c824nqpqvcmtun9h",
//   oauth: {
//     domain: "amtstage.auth.us-west-2.amazoncognito.com",
//     // redirectSignIn: "https://d1b2wkshghzkj7.cloudfront.net/",
//     // redirectSignOut: "https://d1b2wkshghzkj7.cloudfront.net/login/",
//     redirectSignIn: "https://amt.stg.globe.life/",
//     redirectSignOut: "https://amt.stg.globe.life/login/",

//     responseType: "code"
//   },
//   aws_appsync_graphqlEndpoint:
//     "https://d6f5jgkygrcppmvz5mvmfwrhyi.appsync-api.us-west-2.amazonaws.com/graphql",
//   aws_appsync_region: "us-west-2",
//   aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
//   storage: sessionStorage
// };

// PROD:
const awsmobile = {
  aws_project_region: "us-west-2",
  aws_cognito_region: "us-west-2",
  aws_user_pools_id: "us-west-2_BmRzQcS7d",
  aws_user_pools_web_client_id: "4gfdj56m3al5m04gs0r1283vi7",
  oauth: {
    domain: "amtprod.auth.us-west-2.amazoncognito.com",
    redirectSignIn: "https://AMT.globe.life",
    redirectSignOut: "https://AMT.globe.life/login",
    responseType: "code",
  },
  aws_appsync_graphqlEndpoint:
    "https://zazhr4k32zazxorm35lscqkoxq.appsync-api.us-west-2.amazonaws.com/graphql",
  aws_appsync_region: "us-west-2",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  storage: sessionStorage
};

// remember to change API Gateway URL in http-common.js if altering environment here.

// const awsmobile = {
//   aws_project_region: "us-west-2",
//   aws_cognito_region: "us-west-2",
//   aws_user_pools_id: "us-west-2_QESmt7wjp",
//   aws_user_pools_web_client_id: "4vlip18hps0pru094ue1bn8n70",
//   oauth: {
//     domain: "amtdev.auth.us-west-2.amazoncognito.com",

//     redirectSignIn: "http://localhost:8080",
//     redirectSignOut: "http://localhost:8080/login",
//     // // redirectSignIn: "https://da8ksoxhmc8sy.cloudfront.net",
//     // // redirectSignOut: "https://da8ksoxhmc8sy.cloudfront.net/login/",
//     // redirectSignIn: "https://amt.dev.globe.life/",
//     // redirectSignOut: "https://amt.dev.globe.life/login/",
//     responseType: "code",
//   },
//   aws_appsync_graphqlEndpoint:
//     "https://7x2k3mcplvgwxpka2xeowe6psq.appsync-api.us-west-2.amazonaws.com/graphql",
//   aws_appsync_region: "us-west-2",
//   aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
//   storage: sessionStorage
// };

export default awsmobile;
